import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 10h-14l4 -4","key":"svg-0"}],["path",{"d":"M7 14h14l-4 4","key":"svg-1"}]]

/**
 * IconArrowsExchange2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3dzLWV4Y2hhbmdlLTIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3IDEwaC0xNGw0IC00IiAvPgogIDxwYXRoIGQ9Ik03IDE0aDE0bC00IDQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrows-exchange-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowsExchange2 = createReactComponent('outline', 'arrows-exchange-2', 'ArrowsExchange2', __iconNode);

export default IconArrowsExchange2;